import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend
  } from "chart.js";
  import { BASE_URL } from "../services/constant";
  
  
import "./VideoDetailStat.scss";
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
);


const VideoDetailStat = () => {
  const { id } = useParams();

  const [video, setVideo] = useState(null);
  const [stats, setStats] = useState(null);
  const [daily, setDaily] = useState([]);
  
  const formatDuration = (seconds) => {
    if (!seconds) return "00:00";
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return h > 0
      ? `${String(h).padStart(2, "0")}:${String(m).padStart(
          2,
          "0"
        )}:${String(s).padStart(2, "0")}`
      : `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  const formatDate = (d) => {
    return new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };


  useEffect(() => {
    load();
  }, [id]);

  async function load() {
    const v = await fetch(BASE_URL+ "api/contents/" + id).then(r => r.json());
    const s = await fetch(BASE_URL+ "api/contents/stats/content/" + id).then(r => r.json());
    const d = await fetch(BASE_URL+ "api/contents/stats/content/" + id + "/daily").then(r => r.json());

    console.log(s);
    setVideo(v.data);
    setStats(s.data);
    setDaily(d.data);
  }

  if (!video || !stats) return <div>Loading...</div>;

  const chartData = {
    labels: daily.map(d => {
      const date = new Date(d.day);
      return `${date.getDate()}/${date.getMonth() + 1}`; // JJ/MM
    }),
    datasets: [
      {
        label: "Vues par jour",
        data: daily.map(d => d.views),
        borderWidth: 2,
        borderColor: "red",        // ligne rouge
        backgroundColor: "rgba(255,0,0,0.3)", // zone sous la ligne
        tension: 0.3,              // légère courbe
      },
    ],
  };

  const chartOptions = {
    plugins: {
      legend: {
        labels: {
          color: "#fff", // texte légende blanc
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#fff", // texte axe X blanc
        },
        grid: {
          color: "rgba(255,255,255,0.15)", // grille très légère
        }
      },
      y: {
        ticks: {
          color: "#fff", // texte axe Y blanc
        },
        grid: {
          color: "rgba(255,255,255,0.15)" // grille très légère
        }
      }
    }
  };
  
  

  return (
    <div className="page-content">
        <div className="stat-page">

            <h2>Statistiques de : {video.title}</h2>

            <div className="video-info-box">
            <img src={BASE_URL+"api/"+video.image} alt="" className="poster" />


                <div className="info">
                    <h1>{video.title}</h1>

                    <ul>
                        <li><b>ID:</b> {video.id}</li>
                        <li><b>Type:</b> {video.type}</li>
                        <li><b>Duration:</b> {formatDuration(video.duration)}</li>
                        <li><b>Date:</b> {formatDate(video.created_at)}</li>
                        <li><b>Category:</b> Film</li>
                        <li><b>Description :</b>  </li>
                        <li><p>{video.description}</p></li>
                    </ul>
                </div>
            </div>

            <h3>Répartition des visionnages</h3>
            <div className="stats-grid">
                <div className="stat-item"> ≤ 10% <b>{stats.p10}</b> </div>
                <div className="stat-item"> 10% → 50% <b>{stats.p10_50}</b> </div>
                <div className="stat-item"> 50% → 80% <b>{stats.p50_80}</b> </div>
                <div className="stat-item"> 100% <b>{stats.p100}</b> </div>
            </div>

            <h3>Évolution des vues (30 derniers jours)</h3>
            <div className="chart">
                <Line data={chartData} options={chartOptions} />
            </div>

        </div>
    </div>
  );
};

export default VideoDetailStat;
